var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], {"dev":false,"autoescape":true,"throwOnUndefined":false,"trimBlocks":false,"lstripBlocks":false});
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["@templates/components/molecules/card-small.html.njk"] = require( "@templates/components/molecules/card-small.html.njk" );
dependencies["@naturehouse/design-system/components/atoms/button/Button.macro.njk"] = require( "@naturehouse/design-system/components/atoms/button/Button.macro.njk" );




var shim = require("/builds/natuurhuisje/nature.house/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/website/search/partials/flexibleHouseCarouselTemplate.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("@templates/components/molecules/card-small.html.njk", false, "templates/website/search/partials/flexibleHouseCarouselTemplate.html.njk", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("cardSmallTemplate", t_1);
output += "\n";
env.getTemplate("@naturehouse/design-system/components/atoms/button/Button.macro.njk", false, "templates/website/search/partials/flexibleHouseCarouselTemplate.html.njk", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("buttonTemplate", t_4);
output += "\n\n<nh-carousel class=\"nh-houses-carousel__carousel\">\n    <header class=\"nh-houses-carousel__header flex\">\n        <div>\n            <span class=\"h2\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"carouselHeader"), env.opts.autoescape);
output += "</span>\n            <p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"carouselContent"), env.opts.autoescape);
output += "</p>\n        </div>\n\n        ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "houses")) > 3) {
output += "\n            <div class=\"search__flexible-results--controls\">\n                ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 12, colno = 40, runtime.callWrap(runtime.memberLookup((t_4),"render"), "buttonTemplate[\"render\"]", context, [{"label": "","variant": "dark","icon": {"name": "arrow-left"},"data": {"data-action": "prev"}}]))), env.opts.autoescape);
output += "\n                ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 22, colno = 40, runtime.callWrap(runtime.memberLookup((t_4),"render"), "buttonTemplate[\"render\"]", context, [{"label": "","variant": "dark","icon": {"name": "arrow-right"},"data": {"data-action": "next"}}]))), env.opts.autoescape);
output += "\n            </div>\n        ";
;
}
output += "\n    </header>\n\n    <div class=\"nh-houses-carousel__gallery\">\n        <div data-carousel-wrapper>\n            <ul class=\"nh-houses-carousel__gallery-items\" data-carousel-list>\n                ";
frame = frame.push();
var t_9 = runtime.contextOrFrameLookup(context, frame, "houses");
if(t_9) {t_9 = runtime.fromIterator(t_9);
var t_8 = t_9.length;
for(var t_7=0; t_7 < t_9.length; t_7++) {
var t_10 = t_9[t_7];
frame.set("house", t_10);
frame.set("loop.index", t_7 + 1);
frame.set("loop.index0", t_7);
frame.set("loop.revindex", t_8 - t_7);
frame.set("loop.revindex0", t_8 - t_7 - 1);
frame.set("loop.first", t_7 === 0);
frame.set("loop.last", t_7 === t_8 - 1);
frame.set("loop.length", t_8);
output += "\n                    ";
var t_11;
t_11 = (function() {
var output = "";
output += "\n                        ";
if(runtime.memberLookup((t_10),"price")) {
output += "\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"priceFrom"), env.opts.autoescape);
output += " <b class=\"text-gray-dark\">";
output += runtime.suppressValue(runtime.memberLookup((t_10),"formattedPrice"), env.opts.autoescape);
output += "</b>\n                        ";
;
}
else {
output += "\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"discoverBestPrice"), env.opts.autoescape);
output += "\n                        ";
;
}
output += "\n                    ";
;
return output;
})()
;
frame.set("textLeft", t_11, true);
if(frame.topLevel) {
context.setVariable("textLeft", t_11);
}
if(frame.topLevel) {
context.addExport("textLeft", t_11);
}
output += "\n                    ";
var t_12;
t_12 = (function() {
var output = "";
output += "\n                        ";
if(runtime.memberLookup((t_10),"price")) {
output += "\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"pricePerNight"), env.opts.autoescape);
output += "\n                        ";
;
}
else {
output += "\n                            ";
output += runtime.suppressValue("", env.opts.autoescape);
output += "\n                        ";
;
}
output += "\n                    ";
;
return output;
})()
;
frame.set("textLeft2", t_12, true);
if(frame.topLevel) {
context.setVariable("textLeft2", t_12);
}
if(frame.topLevel) {
context.addExport("textLeft2", t_12);
}
output += "\n                    <li class=\"nh-houses-carousel__gallery-link\" data-carousel-item>\n                        ";
output += runtime.suppressValue((lineno = 55, colno = 51, runtime.callWrap(runtime.memberLookup((t_1),"render"), "cardSmallTemplate[\"render\"]", context, [{"house": t_10,"translations": runtime.contextOrFrameLookup(context, frame, "translations"),"footer": {"text_left_1": runtime.contextOrFrameLookup(context, frame, "textLeft"),"text_left_2": runtime.contextOrFrameLookup(context, frame, "textLeft2"),"text_cta": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"visit")},"icon_text": runtime.memberLookup((t_10),"persons") + "" + " " + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"persons"),"isLoggedIn": runtime.contextOrFrameLookup(context, frame, "isLoggedIn")}])), env.opts.autoescape);
output += "\n                    </li>\n                ";
;
}
}
frame = frame.pop();
output += "\n            </ul>\n        </div>\n    </div>\n</nh-carousel>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/website/search/partials/flexibleHouseCarouselTemplate.html.njk"] , dependencies)